<template>
  <div v-if="comboItems.length > 0">
    <hr class="dropdown-divider" />
    <b-dropdown-item custom aria-role="listitem" class="combo-title">
      <b-icon icon="tag" size="is-small" type="is-success" />
      <b>{{ $t("transactions.comboPromotion") }}</b>
    </b-dropdown-item>

    <template v-for="(item, index) in comboItems">
      <hr
        v-if="index > 0"
        :key="`${item._id}-divider`"
        class="dropdown-divider combo-item-divider"
      />
      <b-dropdown-item
        :key="item._id"
        custom
        aria-role="listitem"
        class="combo-item"
      >
        <p class="combo-item-name">{{ item.name }}</p>
        <span class="tag is-success is-light combo-item-tag">
          {{
            $t("transactions.comboPayTake", {
              buyQty: item.combo.buyQty,
              takeQty: item.combo.takeQty
            })
          }}
        </span>
        <b>{{ $t("transactions.comboSplit") }}:</b>
        <p
          v-for="(segment, i) in item.combo.segments"
          :key="i"
          class="combo-item-segment"
        >
          {{ formatSegment(segment) }}
        </p>
        <p>
          <b>{{ $t("transactions.comboTotal") }}: </b>
          {{ `${payments.currencySymbol}${formatMoney(getTotal(item))}` }}
        </p>
        <p v-if="getSavings(item) > 0" class="has-text-success">
          <b>{{ $t("transactions.comboSavings") }}: </b>
          {{ `${payments.currencySymbol}${formatMoney(getSavings(item))}` }}
        </p>
      </b-dropdown-item>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mask } from "../../../mixins/mask";

// "pague X leve Y": o checkout grava em `item.combo` o rateio por unidade (segments)
export default {
  props: ["t"],

  mixins: [mask],

  computed: {
    ...mapGetters(["payments"]),

    comboItems() {
      const items = (this.t.cart && this.t.cart.items) || [];
      return items.filter(
        item =>
          item.combo && item.combo.segments && item.combo.segments.length > 0
      );
    }
  },

  methods: {
    formatSegment(segment) {
      return `${segment.qty} x ${
        this.payments.currencySymbol
      }${this.formatMoney(segment.unitPrice)}`;
    },

    getTotal(item) {
      return item.combo.segments.reduce(
        (sum, s) => sum + s.qty * s.unitPrice,
        0
      );
    },

    getSavings(item) {
      const fullPrice = item.priceFrom ? item.priceFrom : item.price;
      return fullPrice * item.quantity - this.getTotal(item);
    }
  }
};
</script>

<style scoped>
.combo-title {
  display: flex;
  align-items: center;
  gap: 0.375rem;
}
.combo-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 15rem;
  white-space: normal;
  line-height: 1.6;
}
.combo-item-name {
  font-weight: 600;
}
.combo-item-tag {
  margin: 0.25rem 0 0.375rem;
}
.combo-item-segment {
  padding-left: 0.75rem;
}
.combo-item-divider {
  margin: 0.25rem 1rem;
}
</style>
